// extracted by mini-css-extract-plugin
export default {"links-container":"QuickLinks_links-container__7c6x9"};